import {DataNode, TreeProps} from 'antd/lib/tree';
import React, {useEffect, useState} from 'react';
import {Button, Card, Modal, Tree} from 'antd';
import {DownOutlined} from '@ant-design/icons';
import Flex from '../../components/Flex';
import {SpecialtyCommitteeList, WorkCommitteeList} from '../../utils/CommitteeList';
import {useBoolean} from 'react-hanger';
import ArticleEditForm from '../../components/article/EditForm';
import {useOpenApiFpRequest} from '../../Http/useOpenApiRequest';
import {ArticleApi, ArticleDto, ArticleDtoSearchResponseDto} from '../../scaffold';
import {useAntdTable} from 'ahooks';
import AntDTableUtils from '../../utils/AntDTableUtils';
import {DefaultAntdTableConfig} from '../../utils/CommonConfig';
import ArticleTable from '../../components/article/Table';
import useAuth from '../../utils/AuthContext';
function keyToItem(key: string) {
  return {title: key, key};
}
export const ArticleCatalogsTreeData: DataNode[] = [
  {
    title: '关于 SCS',
    key: '关于 SCS',
    children: ['学会简介', '组织机构', '章程条例', '大事记', '联系我们'].map(keyToItem),
  },
  {
    title: '组织架构',
    key: '组织架构',
    children: ['理事会', '监事会', '理事会临时党支部'].map(keyToItem),
  },
  {
    title: '分支机构',
    key: '分支机构',
    children: [
      {title: '工作委员会', key: '工作委员会', children: WorkCommitteeList.map(keyToItem)},
      {title: '专业委员会', key: '专业委员会', children: SpecialtyCommitteeList.map(keyToItem)},
    ],
  },
  {
    title: '会议活动',
    key: '会议活动',
    children: [
      {title: '会议活动总结', key: '会议活动总结'},
      {title: '推荐会议活动', key: '推荐会议活动'},
    ],
  },
  {
    title: '学会奖励',
    key: '学会奖励',
    children: ['优秀博士学位论文奖', '优秀硕士学位论文奖', '教学成果奖', '科技英才', '科学技术奖', '少年图灵奖'].map(keyToItem),
  },
  keyToItem('最新公告'),
  keyToItem('团体会员风采'),
];
export default function ManageArticleListPage() {
  const treeData: DataNode[] = ArticleCatalogsTreeData;
  const [catalogs, _catalogs] = useState('最新公告');
  const isAddArticle = useBoolean(false);
  const searchHook = useOpenApiFpRequest(ArticleApi, ArticleApi.prototype.articleSearchGet);
  const antdConfig = useAntdTable(
    params => {
      console.log(params);
      return searchHook.request({
        ...AntDTableUtils.makeParams(params),
        catalogs: catalogs,
        includeHidden: true,
      });
    },
    {...DefaultAntdTableConfig, refreshDeps: [catalogs]},
  );
  const auth = useAuth();
  useEffect(() => {
    if (auth.currentUser?.isManager) {
      _catalogs(auth.currentUser?.telephone || '');
    }
  }, [auth.currentUser]);
  return (
    <Flex align={'stretch'} style={{height: '100%'}}>
      <Tree
        className={'ArticleCatalogsTree'}
        showLine
        onSelect={(keys, info) => _catalogs(keys[0] as string)}
        treeData={auth.currentUser?.isManager ? ([{title: auth.currentUser?.telephone, key: auth.currentUser?.telephone}] as DataNode[]) : treeData}
      />
      <div style={{flex: 1, padding: 20}}>
        <Card
          title={catalogs}
          extra={
            <Button type={'primary'} onClick={isAddArticle.setTrue}>
              新增文章
            </Button>
          }>
          <ArticleTable antDTable={antdConfig} />
        </Card>
        <Modal title={'新建文章'} destroyOnClose width={1200} visible={isAddArticle.value} maskClosable={false} closable={false} footer={false}>
          <ArticleEditForm
            catalogs={catalogs}
            onCancel={isAddArticle.setFalse}
            onSuccess={res => {
              isAddArticle.setFalse();
              antdConfig.search.submit();
            }}
          />
        </Modal>
      </div>
    </Flex>
  );
}
